export default __webpack_public_path__ + "static/media/25_Papugi.de18e544.JPG";